import { BaseService, Service } from "/@/cool";
@Service("wlOrderLogistics")
class WlOrderLogistics extends BaseService {}
export default WlOrderLogistics;
